// extracted by mini-css-extract-plugin
module.exports = {"machine_compact":"machine_compact--1GRrRoqb5","machine_compact__actions":"machine_compact__actions--2MWwwrVc_","machine_compact__active":"machine_compact__active--13nxnEhTF"};